// src/components/dashboards/Vendor/adminvendors/VendorList.js

import React, { useState } from "react";

export default function VendorList({
  vendors = [],
  onEdit,
  onDelete
}) {
  const [search, setSearch] = useState("");
  
const filteredVendors = vendors.filter((v) => {
  const name = v?.name || "";
  
  const email = v?.email || "";
  const phone = v?.phone || "";
  const vendorId = v?.vendorCode || "";

  const searchText = search.toLowerCase();

  const locationText = `
${v.location?.city || ""}
${v.location?.district || ""}
${v.location?.state || ""}
${v.location?.pincode || ""}
`.toLowerCase();

const matchSearch =
  name.toLowerCase().includes(searchText) ||
  email.toLowerCase().includes(searchText) ||
  phone.includes(searchText) ||
  vendorId.toLowerCase().includes(searchText) ||
  locationText.includes(searchText);

return matchSearch;

  
});

  return (
    <section className="admin-card">
      <h3>Vendors</h3>

      {/* 🔍 Search + Filter */}
      <div style={{ display: "flex", gap: 10, marginBottom: 12 }}>
        <input
          placeholder="Search Vendor, ID, Phone, Email, City, District, Pincode..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

      
      </div>

      <table className="admin-table">
        <thead>
          <tr>
            <th>Vendor ID</th>
            <th>Name</th>
            <th>Location</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Location</th>
            <th>Map</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {filteredVendors.map((v) => (
            <tr key={v._id}>
              <td>{v.vendorCode || "-"}</td>
              <td>{v.name}</td>
              <td>
  <div>
    <strong>{v.location?.city || "-"}</strong>

    <br />

    <small style={{ color: "#666" }}>
      {v.location?.district}
    </small>
  </div>
</td>
              <td>{v.phone}</td>
              <td>{v.email}</td>
              <td>
{
v.location?.latitude
?

<span style={{color:"#16a34a"}}>
📍 Added
</span>

:

<span style={{color:"#dc2626"}}>
Not Added
</span>

}
</td>

<td>

{
v.location?.latitude &&

<a
href={`https://www.google.com/maps?q=${v.location.latitude},${v.location.longitude}`}
target="_blank"
rel="noreferrer"
className="admin-secondary-btn"
>

View

</a>

}

</td>
              <td>
                <button
                  className="admin-secondary-btn"
                  onClick={() => onEdit(v)}
                >
                  Edit
                </button>{" "}
                <button
                  className="admin-secondary-btn"
                  onClick={() => onDelete(v._id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}

          {filteredVendors.length === 0 && (
            <tr>
              <td colSpan="8">No vendors found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </section>
  );
}
